// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

//imports components
import styles from "../styles/profile.module.css";
import { Menu } from "../components/Menu";

import { urlAPI_Current } from "../config";
import { logoutUser } from "../logoutUser";
import { userLogged } from "../userLogged";
import { verifyUserPaid } from "../verifyUserPaid";
import { UserInfoProfile } from "../components/UserInfoProfile";
import { UserEditProfile } from "../components/UserEditProfile";
import { UserSkillsProfile } from "../components/UserSkillsProfile";
import { UserReportsProfile } from "../components/UserReportsProfile";
import { UserPaymentsProfile } from "../components/UserPaymentsProfile";
import { SwitchMode } from "../components/SwitchMode";
import { BookA } from "lucide-react";
import useAccessTracking from "../components/useAccessTracking";
import { verifyAuthToken } from "../verifyAuthToken";

export function Profile() {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [userData, setUserData] = useState([]);
  const [activeTab, setActiveTab] = useState('dados');
  const [photoUpdated, setPhotoUpdated] = useState(false);
  const [planActually, setPlanActually] = useState([]);
  const navigateTo = useNavigate();
  const [planType, setPlanType] = useState('');

  
  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  useAccessTracking();

  const handleModeChange = (darkMode) => {
    setDarkMode(darkMode);
  };

  async function getUserLogged(){
    const user = await userLogged();
    setUserData(user)

    if (!user) { // não tiver usuário, ou authToken invalido
      toast.error('Faça o login primeiro');
      navigateTo('/login');
    } 
    else if(user.codTipoUsuario != 1){
      logoutUser();
      toast.error('Você não tem acesso a essa página');
      navigateTo('/login');
    } else { // loga
        const responsePaid = await verifyUserPaid();
        if(responsePaid.success == true){
          console.log(`Plano Atual ${responsePaid.plan}`);
        } else {
          
        }
    }
  }

  const handleEditProfile = () => {
    setActiveTab('editar');
  };

  
  useEffect(() => {
    const fetchData = async () => {
      const responsePaid = await verifyUserPaid();
      console.log(responsePaid);

      if(responsePaid.success == true){
          console.log(`Plano Atual ${responsePaid.plan}`);
          setPlanActually(responsePaid.plan); 
          const typePaid = responsePaid.type;

          if(typePaid == 'convite'){
            setPlanType('convite');
          } else if (typePaid == 'plano') {
            setPlanType('plano')
            console.log("caiu no plano");
          }
      }
      
      await getUserLogged();
    };

    fetchData();
  }, [darkMode]);

  const handleUpdate = () => {
    getUserLogged();
    setPhotoUpdated(true);

    setTimeout(() => setPhotoUpdated(false), 3000); 
  };

  useEffect(() => {
    verifyAuthToken(navigateTo);
}, []);

  return (
    <div className={styles.profile}>
      <Menu darkMode={darkMode} buttonBack={true} photoUpdated={photoUpdated}/>
      <div className={styles.containerProfile}>
  <div className="card mb-6" data-bs-theme={darkMode ? 'dark' : 'light'}>
    <div className="card-body pt-9 pb-0">
      <div className="d-flex flex-wrap flex-sm-nowrap">
        <div className="me-7 mb-4 mb-md-3">
          <div className="symbol symbol-200px symbol-lg-200px symbol-fixed position-relative d-flex align-items-center justify-content-center bg-primary text-white">
          {userData && userData.foto ? (
            <img
              src={`https://evoktm.com.br/evokchat/fotos_usuarios/${userData.foto}`}
              alt="Foto do usuário"
              style={{ width: '200px', height: '200px', objectFit: 'cover' }}
            />
          ) : (
            <span className="d-flex align-items-center justify-content-center" style={{ width: '200px', height: '200px' }}>
              <span style={{ fontSize: '46px' }}>
                {userData && userData.nome ? userData.nome.slice(0, 2).toUpperCase() : 'N/A'}
              </span>
            </span>
          )}
            <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-30px w-30px"></div>
          </div>
        </div>

        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center mb-2">
                <p className="text-gray-900 text-hover-primary fs-2 fw-bold me-1">
                  {userData.nome}
                </p>
                <p>
                  <i className="ki-outline ki-verify fs-1 text-primary"></i>
                </p>
              </div>

              <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                <p className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
                  <i className="ki-outline ki-sms fs-4 me-1"></i>
                  {userData.email}
                </p>
              </div>

              {planType == 'convite' ? (
                <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                  <p className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
                    <BookA size={18}/>
                    Plano: EvokReport
                  </p>
                </div>
              ) : planType == 'plano' ? (
                <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                  <p className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
                    <BookA size={18}/>
                    Plano: EvokPersona
                  </p>
                </div>
              ) : (
                <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                  <p className="d-flex align-items-center text-gray-500 text-hover-primary mb-2">
                    <BookA size={18}/>
                    Plano: Nenhum
                  </p>
                </div>
              )} 
            </div>

            <div className="d-flex my-4">
              <div className="me-0">
                <button className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                  <i className="ki-solid ki-dots-horizontal fs-2x"></i>
                </button>

                <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-kt-menu="true">
                  <div className="menu-item px-3">
                    <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                      Payments
                    </div>
                  </div>
                  <div className="menu-item px-3">
                    <a href="#" className="menu-link px-3">
                      Create Invoice
                    </a>
                  </div>
                  <div className="menu-item px-3">
                    <a href="#" className="menu-link flex-stack px-3">
                      Create Payment
                      <span className="ms-2" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference">
                        <i className="ki-outline ki-information fs-6"></i>
                      </span>
                    </a>
                  </div>
                  <div className="menu-item px-3">
                    <a href="#" className="menu-link px-3">
                      Generate Bill
                    </a>
                  </div>
                  <div className="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">
                    <a href="#" className="menu-link px-3">
                      <span className="menu-title">Subscription</span>
                      <span className="menu-arrow"></span>
                    </a>
                    <div className="menu-sub menu-sub-dropdown w-175px py-4">
                      <div className="menu-item px-3">
                        <a href="#" className="menu-link px-3">
                          Plans
                        </a>
                      </div>
                      <div className="menu-item px-3">
                        <a href="#" className="menu-link px-3">
                          Billing
                        </a>
                      </div>
                      <div className="menu-item px-3">
                        <a href="#" className="menu-link px-3">
                          Statements
                        </a>
                      </div>
                      <div className="separator my-2"></div>
                      <div className="menu-item px-3">
                        <div className="menu-content px-3">
                          <label className="form-check form-switch form-check-custom form-check-solid">
                            <input className="form-check-input w-30px h-20px" type="checkbox" value="1" name="notifications" />
                            <span className="form-check-label text-muted fs-6">
                              Recuring
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-item px-3 my-1">
                    <a href="#" className="menu-link px-3">
                      Settings
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-wrap flex-stack">
            <div className="d-flex flex-column flex-grow-1 pe-8">
              <div className="d-flex flex-wrap">
                
              </div>
            </div>

            <div className="d-flex flex-column mt-3 mb-3 mb-md-4 w-75 w-md-300px align-items-center align-items-md-start md-w-50" style={{ paddingBottom: "10px" }}>
              <div className="d-flex justify-content-between w-75">
                <span className="fw-semibold fs-6 text-gray-500">Modo da Interface</span>
                <span className="fw-bold fs-6">{darkMode ? "Modo Escuro" : "Modo Claro"}</span>
              </div>
                  <SwitchMode onModeChange={handleModeChange} />
                </div>
                </div>
              </div>
            </div>

            <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
              <li className="nav-item mt-2">
                <p
                  className={`nav-link text-active-primary ms-0 me-10 py-5 ${activeTab === 'dados' ? 'active' : ''}`}
                  onClick={() => setActiveTab('dados')}
                  style={{cursor: "pointer"}}
                >
                  Dados
                </p>
              </li>

              <li className="nav-item mt-2">
                <p
                  className={`nav-link text-active-primary ms-0 me-10 py-5 ${activeTab === 'editar' ? 'active' : ''}`}
                  onClick={() => setActiveTab('editar')}
                  style={{cursor: "pointer"}}
                >
                  Editar
                </p>
              </li>

              <li className="nav-item mt-2">
                <p
                  className={`nav-link text-active-primary ms-0 me-10 py-5 ${activeTab === 'habilidades' ? 'active' : ''}`}
                  onClick={() => setActiveTab('habilidades')}
                  style={{cursor: "pointer"}}
                >
                  Habilidades
                </p>
              </li>

              <li className="nav-item mt-2">
                <p
                  className={`nav-link text-active-primary ms-0 me-10 py-5 ${activeTab === 'relatorios' ? 'active' : ''}`}
                  onClick={() => setActiveTab('relatorios')}
                  style={{cursor: "pointer"}}
                >
                  Relatórios
                </p>
              </li>

              <li className="nav-item mt-2">
                <p
                  className={`nav-link text-active-primary ms-0 me-10 py-5 ${activeTab === 'pagamentos' ? 'active' : ''}`}
                  onClick={() => setActiveTab('pagamentos')}
                  style={{cursor: "pointer"}}
                >
                  Pagamentos
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content mt-4">
        {activeTab === 'dados' ? (
          <UserInfoProfile userData={userData} darkMode={darkMode} onEditProfile={handleEditProfile} />
        ) : activeTab === 'editar' ? (
          <UserEditProfile darkMode={darkMode} onUpdate={handleUpdate} />
        ) : activeTab === 'habilidades' ? (
          <UserSkillsProfile userData={userData} darkMode={darkMode} />
        ) : activeTab === 'relatorios' ? (
          <UserReportsProfile userData={userData} darkMode={darkMode} />
        ) : activeTab === 'pagamentos' ? (
          <UserPaymentsProfile darkMode={darkMode} />
        ) : null}
        </div>
       
      </div>
    </div>
  );
}
